import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../state/reducers";
import { dm_truong } from "../models/response/category/dm_truong";
import { actions } from "../state/actions/actionsWrapper";

export const useCommonSelectedHook = () => {
    const { dm_truong_selected_id, nam_hoc, hoc_ky } = useSelector((x: RootState) => x.common);
    const { dm_truongs } = useSelector((x: RootState) => x.categorySource);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!dm_truongs || dm_truongs.length === 0) {
            dispatch(actions.categorySource.loadDmTruongStart());
        }
    }, [dispatch, dm_truongs]);

    const dm_coso_id = useMemo(() => {
        if (!dm_truong_selected_id) {
            return 0;
        }
        
        if (dm_truongs && dm_truongs.length > 0) {
            const truong = dm_truongs.find((t: dm_truong) => Number(t.id) === Number(dm_truong_selected_id));
            if (truong) {
                return truong.dm_coso_id || 0;
            }
        }
        
        return 0;
    }, [dm_truong_selected_id, dm_truongs]);

    return {
        dm_truong_id: dm_truong_selected_id,
        dm_coso_id,
        nam_hoc,
        hoc_ky,
        dm_he_id: 0
    };
}
